import styled from 'styled-components'
import variablesApplicationConfig from '../../../variables'

const ContainerFooterCircular = styled.div`
  width: 100%;
  height: 490px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;

  background-color: ${(props) =>
    props.color ? 'var(--primary-color)' : 'var(--secondary-color)'};

  border-top: 1px solid white;

  color: white;

  overflow: hidden;

  position: relative;

  .middle-section {
    width: 100%;
    height: 100%;
    max-width: ${() => variablesApplicationConfig.desktopBreakpoint}px;

    margin-top: 60px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;

    .m-s-top {
      width: 100%;

      display: flex;

      padding: 0px 30px;

      .m-s-t-left {
        width: 50%;

        .content-image-logo-marca {
          display: flex;
          align-items: center;

          gap: 20px;

          margin-bottom: 30px;

          cursor: pointer;

          img {
            width: auto;
            height: 60px;
            box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
            border-radius: 12px;
          }

          .logo-marca {
            font-size: 18px;
            font-weight: 700;
          }
        }

        .description {
          color: black;
          font-size: 16px;
          line-height: 30px;

          width: 100%;
          max-width: 600px;

          margin-bottom: 30px;
          color: white;

          font-size: 14px;
          font-weight: 700;
        }

        .box-icon-contact {
          display: flex;
          gap: 25px;
          font-size: 20px;
          color: white;

          align-items: center;

          cursor: pointer;

          .facebook {
            font-size: 24px;
          }
        }
      }
      z-index: 1;
    }

    .m-s-bottom {
      width: 100%;
      height: 90px;
      border-top: 0.5px solid rgba(255, 255, 255, 0.2);

      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 0px 30px;

      /* color: rgba(255, 255, 255, 0.6); */
      color: white;

      font-size: 14px;
      font-weight: 700;

      .m-s-t-right {
        display: flex;
        gap: 35px;

        text-decoration: none;
        /* color: rgba(255, 255, 255, 0.6); */

        color: white;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        &:hover {
          color: black;
        }
      }
      z-index: 1;
    }

    .position-background-absolute {
      position: absolute;
      top: 0;
      z-index: 0;
    }
  }

  @media (max-width: ${() => variablesApplicationConfig.mobileBreakpoint}px) {
    height: 100% !important;
    .middle-section {
      height: 100% !important;
      .m-s-top {
        height: 100% !important;
        align-items: center !important;
        justify-content: center;
        .m-s-t-left {
          display: flex;
          flex-direction: column;
          align-items: center !important;
          .description {
            text-align: center;
          }
        }
      }
      gap: 100px;
      .m-s-bottom {
        height: 100% !important;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        height: 100% !important;
        padding-bottom: 30px;
        .m-s-t-left {
          display: flex;
          align-items: center !important;
          text-align: center;
          padding: 30px 10px;
          font-size: 14px;
        }
        .m-s-t-right {
          gap: 10px !important;
          .link {
            font-size: 14px;
            text-align: center;
          }
        }
      }
    }
  }
`

export default ContainerFooterCircular
